enum ResizedImageId {
    L = 'large',
    Lw = 'large-webp',
    M = 'medium',
    Mw = 'medium-webp',
    S = 'small',
    Sw = 'small-webp',
    T = 'thumb',
    Tw = 'thumb-webp',
}

export default ResizedImageId;
